import {CardContent, Card, Stack, styled} from '@mui/material';
import {StyledCardContentProps} from './types';

const StyledCard = styled(Card)`
	display: flex;
	flex-direction: column-reverse;

	${({theme}) => theme.breakpoints.up('sm')} {
		flex-direction: row;
		max-width: 852px;
		margin: 0 auto;
	}
`;

const StyledCardContent = styled(CardContent)<StyledCardContentProps>`
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 16px;
	justify-content: ${({isWellBorn}) => (isWellBorn ? null : 'space-between')};
`;

const ContentStack = styled(Stack)`
	gap: 16px;
`;

const ButtonsStack = styled(Stack)<StyledCardContentProps>`
	gap: ${({isWellBorn}) => (isWellBorn ? '16px' : '0')};
`;

const BoldTypography = styled('span')`
	font-weight: 700;
`;

export {StyledCard, StyledCardContent, ContentStack, ButtonsStack, BoldTypography};
